<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title
      >
        <v-icon class="mr-2" color="primary lighten-1"> mdi-bell-plus</v-icon>
        {{ selectedProduct.name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-title>
      {{ text }}
    </v-card-title>
    <v-card-text>
      <p>
        You may also place a LIMIT order for this product, which will
        automatically be executed if/when your price threshold is met and the
        product becomes available.
      </p>
      <p>Limit orders are given priority over stock notifications.</p>
      <v-divider class="mt-5 mb-5"></v-divider>
      <v-row>
        <v-col cols="12" md="6">
          <buy-sell-button
            :item="selectedProduct"
            :buy-sell="buySell"
            :show-formulas="false"
            width="100%"
            height="36px"
            limitOrder="true"
          ></buy-sell-button>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn min-width="100%" color="secondary" @click="close">
            Continue Trading
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import productMixin from '@/mixins/product'
import BuySellButton from '@/components/cart/BuySellButton'

export default {
  components: {BuySellButton},
  props: ['selectedProduct', 'buySell', 'text'],
  mixins: [productMixin],
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
